import { render, staticRenderFns } from "./Paragraph.component.vue?vue&type=template&id=4478bc1c&scoped=true"
import script from "./Paragraph.component.vue?vue&type=script&lang=js"
export * from "./Paragraph.component.vue?vue&type=script&lang=js"
import style0 from "./Paragraph.component.vue?vue&type=style&index=0&id=4478bc1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4478bc1c",
  null
  
)

export default component.exports